/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { ILoggingService } from "@common/service/logging.service";
import { TargetEnum, PermissionsEnum } from "@common/model/subject";
import _ from "lodash";
import { Util } from "@common/util";
import { WorkflowActions } from "@common/model/form";
import { LoggingDetail } from "@common/model/loggingDetail";
import { BlobServiceClient } from '@azure/storage-blob';

  export class FormService {
    viewForm: Function;
    fillForm: Function;
    manageForms: Function;
    remindNow: Function;
    validateUnAssignedForm: Function;
    submitForm: Function;
    displaySubmitErrors: Function;
    handleFormSubmittedToMe;
    isFormAssignable: Function;
    isRprtFrmAssignable: Function;
    qckAssgnFrm: Function;
    uploadFrmDocs: Function;
    logAction: Function
    triggerWorkflow: Function;
    updateServiceNote: Function;
    checkSubmitterRole: Function;
    navigateTo: Function;
    printBlock: Function;
    printLayout:Function;
    formUploadInProgress: Function;
    currentUser;

    // Number of form-document uploads currently in flight (see uploadFrmDocs).
    private _activeFormUploads: number = 0;
    // Browser beforeunload guard, registered while a form upload is in progress.
    private unloadFunction = (e) => {
        if (this._activeFormUploads > 0) {
            let confirmationMessage = Util.FORM_UPLD_PROGRESS;
            e.returnValue = confirmationMessage;
            return confirmationMessage;
        }
    };

    // Reset upload tracking during logout so that navigation guards no longer
    // block the state transition (mirrors MultipleUploadService.reset()).
    resetUploads = (): void => {
        this._activeFormUploads = 0;
        window.removeEventListener("beforeunload", this.unloadFunction, true);
    };

    static $inject = ["$sce", "$q", "$state", "Upload", "ApiAdapterService", "CacheService",
        "$rootScope", "LoggingService", "$uibModal", "PopUpService", "$timeout", "authConfig", "storageConfig", "DocumentService","BroadcastService", "ecareEnv", "$ocLazyLoad"];
    constructor($sce, $q, $state, Upload, ApiAdapterService, CacheService, $rootScope,
        $_log: ILoggingService, $uibModal, PopUpService, $timeout, authConfig, storageConfig, private DocumentService,BroadcastService, private ecareEnv: string, private $ocLazyLoad) {

      // App-wide "is a form document upload happening" check, mirrors
      // MultipleUploadService.docUpldInProgress(). Consumed by the leave-page guards.
      this.formUploadInProgress = () => this._activeFormUploads > 0;

      this.manageForms = (page: string, subjectId?: number, reload?) => {
        // If the forms module is already loaded, go directly to the state. Otherwise, use the gateway.
        if (this.$ocLazyLoad.isLoaded('eCareVault.forms')) {
            if(reload){
              $state.go('parent.forms.manage-forms', { page: page, subjectId: subjectId }, { reload: true });
              return;
            }
            $state.go('parent.forms.manage-forms', { page: page, subjectId: subjectId });
        } else {
            $state.go('forms-load', { page: page, subjectId: subjectId });
        }
      }

      this.viewForm = (formId: number, asgnId: number, ref: string, subjectId?: number, reload?) => {
        // If the forms module is already loaded, go directly to the state. Otherwise, use the gateway.
        if (this.$ocLazyLoad.isLoaded('eCareVault.forms')) {
            if(reload){
              $state.go('parent.forms.view', { formId: formId, asgnId: asgnId, ref: ref, subjectId: subjectId }, { reload: true });
              return;
            }
            $state.go('parent.forms.view', { formId: formId, asgnId: asgnId, ref: ref, subjectId: subjectId });
        } else {
            $state.go('forms-load', { action: 'view', formId: formId, asgnId: asgnId, ref: ref, subjectId: subjectId });
        }
      }

      this.fillForm = (asgnId: number, ref: string, subjectId?: number, reload?) => {
        // If the forms module is already loaded, go directly to the state. Otherwise, use the gateway.
        if (this.$ocLazyLoad.isLoaded('eCareVault.forms')) {
            if(reload){
              $state.go('parent.forms.fill', { asgnId: asgnId, ref: ref, subjectId: subjectId }, { reload: true });
              return;
            }
            $state.go('parent.forms.fill', { asgnId: asgnId, ref: ref, subjectId: subjectId });
        } else {
            $state.go('forms-load', { action: 'fill', asgnId: asgnId, ref: ref, subjectId: subjectId });
        }
      }

      this.handleFormSubmittedToMe = () => {
        //this is overridden from manageFormController
      };

      this.remindNow = (asgnId: number) => {
        ApiAdapterService.sendFormAssignedReminder(asgnId).then((s) => {
          toastr.success(Util.REMIND_NOW_SUCCESS);
        }, (e) => {
          toastr.success(Util.REMIND_NOW_FAILURE);
          console.log(e);
        });
      }

      this.validateUnAssignedForm = (fields, formId) => {
        var deferred = $q.defer();
        ApiAdapterService.validateUnAssignedForm(fields, formId).then((s) => {
          deferred.resolve(true);
        }, (e) => {
          deferred.reject(e);
          console.log(e);
        });
        return deferred.promise;
      }
      this.triggerWorkflow = (form, workflowActionEnum, fromSubmit?) => {
        var deferred = $q.defer();
        var wkflTitle, wkflText, submitLabel, cancelLabel, cancelText;
        let subjectId = form.subjectId;
        if (workflowActionEnum == WorkflowActions.PENDING_MIGRATION) {
          wkflTitle = "Assign to a Team";
          wkflText = fromSubmit ? "Submission successful! " + Util.WORKFLOW_PENDING_MIGRATION_TEXT : Util.WORKFLOW_PENDING_MIGRATION_TEXT;
          submitLabel = "Assign";
          cancelLabel = "Close";
          subjectId = null;
        } else if (workflowActionEnum == WorkflowActions.BEGIN_DETERMINATION) {
          wkflTitle = "Begin ARD Determination";
          wkflText = $sce.trustAsHtml(Util.WORKFLOW_TEXT.replace('$to', 'ARD Determination')
            .replace('$from', 'ARD Recommendation'));
          submitLabel = "Begin";
          cancelLabel = "Close";
          cancelText = $sce.trustAsHtml(Util.WORKFLOW_CANCEL_TEXT);
        } else if (workflowActionEnum == WorkflowActions.ASSIGN_SERVICE) {
          wkflTitle = "Assign Service(s)";
          wkflText = $sce.trustAsHtml(Util.WORKFLOW_TEXT.replace('$to', 'Service(s)')
            .replace('$from', 'ARD Determination'));
          submitLabel = "Assign";
          cancelLabel = "Close";
          cancelText = $sce.trustAsHtml(Util.WORKFLOW_CANCEL_TEXT);
        }
        $uibModal.open({
          templateUrl: 'app/common/popup/formWorkflow/formWorkflow.html',
          controller: 'FormWorkflowController',
          controllerAs: 'frmWkfVm',
          windowClass: 'frm-wkfl-modal',
          backdrop: 'static',
          resolve: {
            assgnId: () => form.assignmentId,
            subjectId: () => subjectId,
            wkflTitle: () => wkflTitle,
            wkflText: () => wkflText,
            workflowActionEnumValue: () => workflowActionEnum,
            submitLabel: () => submitLabel,
            cancelLabel: () => cancelLabel,
            cancelText: () => cancelText,
            additionalParams: () => form.additionalParams
          }
        }).result.then(
          (s) => {
            if (workflowActionEnum == WorkflowActions.PENDING_MIGRATION) {
              toastr.success("Team Assignment Successful");
              deferred.resolve(s);
            } else if (_.includes([WorkflowActions.BEGIN_DETERMINATION, WorkflowActions.ASSIGN_SERVICE], workflowActionEnum)) {
              toastr.success("Submission successful. You will be notified of any updates.");
              deferred.resolve(s);
            }
          }, (e) => {
            if (!!e) {
              toastr.success(Util.WORKFLOW_FAILURE_MSG.replace('$action', wkflTitle));
            }
            deferred.reject();
          });
        return deferred.promise;
      }

      this.submitForm = (asgnId: number) => {
        var deferred = $q.defer();
        var password = CacheService.getPassword();
        ApiAdapterService.submitAssignedForm(asgnId, password).then((s) => {
          deferred.resolve(true);
        }, (e) => {
          this.displaySubmitErrors(e.errorCode);
          deferred.reject(e);
          console.log(e);
        });
        return deferred.promise;
      }

      this.updateServiceNote = (noteId, noteTypeId, serviceDate, assignedServiceId, formData?, deactivate?) => {
        var deferred = $q.defer();
        let payload = {};
        payload['id'] = noteId;
        payload['noteId'] = noteTypeId;
        var serviceDateTimestamp = Util.getUTCTime(new Date(serviceDate));
        if (serviceDateTimestamp > Util.getUTCTime(new Date())) {
          PopUpService.openInformationModal(Util.FUTURE_SERVICE_DATE_ERROR);
          $timeout(() => {
            deferred.reject();
          }, 1000);
          return deferred.promise;
        }
        payload['serviceDate'] = serviceDateTimestamp;
        payload['password'] = CacheService.getPassword();
        if (!!formData) {
          payload['fields'] = formData['fields'];
          payload['assignmentId'] = formData['assignmentId'];
        } else if (!!deactivate) {
          payload['deleted'] = true;
        }

        ApiAdapterService.updateServiceNoteForm(assignedServiceId, payload).then((s) => {
          deferred.resolve();
        }, (e) => {
          deferred.reject(e);
        });
        return deferred.promise;
      }

      this.displaySubmitErrors = (errorCode: string) => {
        var msg = Util.FAILURE_MSG;
        if (errorCode == 'SUBMIT_FORM_INCOMPLETE') {
          msg = Util.FORM_SUBMIT_MSGS.INCOMPLETE
        } else if (errorCode == 'SUBMIT_FORM_GENERIC') {
          msg = Util.FORM_SUBMIT_MSGS.GENERIC
        } else if (errorCode == 'SUBMIT_FORM_GETASSIGNMENT_FAIL') {
          msg = Util.FORM_SUBMIT_MSGS.GETASSIGNMENT_FAIL
        } else if (errorCode == 'SUBMIT_FORM_NOT_ASSIGNEE') {
          msg = Util.FORM_SUBMIT_MSGS.NOT_ASSIGNEE
        } else if (errorCode == 'SUBMIT_FORM_UPDATE_FAIL') {
          msg = Util.FORM_SUBMIT_MSGS.UPDATE_FAILED
        } else if (errorCode == 'FORM_ALREADY_SUBMITTED') {
          msg = Util.FORM_ALREADY_SUBMITTED_ERROR
        }
        toastr.success(msg);
      }

      this.isFormAssignable = (subj, form, perm,user,allowFor?) => {
          //If the userExperience available for worker then worker should be able to self assign the form
          if (!user.organizationId) {
              let experienceUser = CacheService.getUserExperience();
              user.organizationId = Util.safeAccess(experienceUser, ['sponsor', 'orgId']);
          }
        if (form.reportEnabled && user.organizationId != subj.teamOrgId) {
          toastr.success(Util.DTT_FORM_INFO, '', { timeOut: 3000 });
          return false;
        } else if (subj.isFrozen) {
          toastr.success(Util.RESTRICT_ASSIGN_FORM_FROZEN, '', { timeOut: 3000 });
          return false;
        } else {
          if (!!perm) {
            return true;
          } else if(allowFor) {
            if (allowFor != subj.subjectId){
              toastr.success(Util.RESTRICT_ASSIGN_OWN_TEAM, '', { timeOut: 3000 });
              return false;
            }
            return true;
          } else {
            if (subj.isFormerTeamMember) {
              toastr.success(Util.RESTRICT_ASSIGN_FORM, '', { timeOut: 3000 });
              return false;
            } else if (!subj.isTeamMember) {
              toastr.success(Util.RESTRICT_ASSIGN_FORM_NOTTM, '', { timeOut: 3000 });
              return false;
            } else {
              return true;
            }
          }
        }
      }

      this.isRprtFrmAssignable = (reportEnabled, user, subj) => {
          //If the userExperience available for worker then worker should be able to self assign the form
          if (!user.organizationId) {
              let experienceUser = CacheService.getUserExperience();
              user.organizationId = Util.safeAccess(experienceUser, ['sponsor', 'orgId']);
          }
        if (reportEnabled && user.organizationId != subj.teamOrgId) {
          toastr.success(Util.DTT_FORM_INFO, '', { timeOut: 3000 });
          return false;
        }
        return true;
      }

      this.qckAssgnFrm = (form, subjId, userId) => {
        $rootScope.mainShowLoader = "Assigning Form...";
        let formUsers = [];
        if (!form.roles || form.roles.length == 0) {
          let user = {
            "userId": userId,
            "role": "ACCESS"
          };
          formUsers.push(user);
        }
        ApiAdapterService.assignFormToUser(form.id, subjId, formUsers).then(
          (s) => {
            if (form.roles) {
              this.viewForm(0, s.assignedFormId, 'avfqa');
            } else {
              this.fillForm(s.assignedFormId, 'avfqa');
            }
          },
          (e) => {
            $rootScope.mainShowLoader = null;
            console.log(e);
            toastr.success(Util.ASSIGN_FORM_ERROR);
          });
      }

      this.logAction = (event, formId, startTime, success) => {
        // check formId has no non-numerical characters
        if (!extModule && (/^\d+$/.test(formId))) {
          let logDetail = new LoggingDetail(event, formId, startTime, Date.now(), success);
          $_log.logAction(logDetail);
        }
      }



      this.uploadFrmDocs = (formId, documents, totalDocs, module?) => {
        var deferred = $q.defer();
        if (!!totalDocs) {
          // Track the in-flight upload and warn the user before they leave the tab
          // while it is running (the upload is canceled on unload otherwise).
          this._activeFormUploads++;
          window.addEventListener("beforeunload", this.unloadFunction, true);

          // Keep the leave-page guard up until EVERY file in this batch has settled
          // (uploaded or failed) — not just until the deferred settles. Otherwise a
          // single file failing (which rejects the deferred) would drop the guard
          // while the other files are still uploading, letting the user leave and
          // silently cancel them.
          let dispatched = 0, settled = 0, allDispatched = false, guardCleared = false;
          const clearGuard = () => {
            if (guardCleared) { return; }
            guardCleared = true;
            this._activeFormUploads--;
            if (this._activeFormUploads <= 0) {
              this._activeFormUploads = 0;
              window.removeEventListener("beforeunload", this.unloadFunction, true);
            }
          };
          const onSettled = () => {
            settled++;
            if (allDispatched && settled >= dispatched) {
              clearGuard();
            }
          };

          var uploadDoc = (sasString) => {
            $rootScope.mainShowLoader = "Uploading Documents...";
            var context = this;
            var cred, folder, crnt = 0;
            var bucketPrefix = (ecareEnv == 'my') ? 'my-' : '';
            var bucket = module == "CREATE_TEAM"? bucketPrefix + 'team-doc-upload-ecarevault-com' : bucketPrefix + 'form-doc-upload-ecarevault-com';
            folder = (!!extModule) ? '/external-form/' : '/form/';

            const folderPath = module == "CREATE_TEAM"? formId + "/" : ecareEnv + folder + formId + "/";
            try {
              const storageUrl = storageConfig.url;
              const blobServiceClient = new BlobServiceClient(`${storageUrl}?${sasString}`);
              const containerClient = blobServiceClient.getContainerClient(bucket);
              Object.keys(documents).forEach(k => {
                for (let i = 0; i < documents[k].length; i++) {
                  var doc = documents[k][i];
                  var name = doc.filename;
                  console.log("uploading : ", doc.filename);
                  let startTime = Date.now();
                  let logDetail;
                  let docName = folderPath + k + "/" +name;
                  var options = {
                    "metadata": {
                      "title": doc.title
                    }
                  };
                  !!doc.folderName && (options.metadata['folderName'] = doc.folderName);
                  const blockBlobClient = containerClient.getBlockBlobClient(docName);
                  dispatched++;
                  blockBlobClient.uploadData(doc.photoFile, options).then((response) => {
                      // context.logAction($_log.events.FORM_UPLOAD_DOC, formId, startTime, true) ;
                      $rootScope.mainShowLoader = "Uploaded " + (++crnt) + " of " + totalDocs + " documents";
                      console.log("Successfully uploaded!");
                      if (crnt == totalDocs) {
                        $rootScope.mainShowLoader = false;
                        deferred.resolve(true);
                      }
                      onSettled();
                  }).catch((error) => {
                      console.log('error uploading file to azure', error);
                      console.log("Error: " + error);
                      // context.logAction($_log.events.FORM_UPLOAD_DOC, formId, startTime, false);
                      deferred.reject(error);
                      onSettled();
                  });
                }
              });
              // All uploads for this batch have now been kicked off; the guard can be
              // released once every dispatched file settles (see onSettled).
              allDispatched = true;
              if (dispatched === 0 || settled >= dispatched) {
                clearGuard();
              }
            } catch (error) {
              console.log('Error', error);
              // Settle the promise and release the guard — this batch never got
              // (fully) in flight, so nothing is left uploading to warn about.
              deferred.reject(error);
              clearGuard();
            }
          };
          const sassObject = CacheService.getSASSToken();
          if (!!sassObject && !!sassObject.expiryTime && sassObject.expiryTime > new Date().toISOString()) {
            uploadDoc(sassObject.sasToken);
          } else {
            ApiAdapterService.getSASSToken().then((token) => {
              CacheService.setSASSToken(token);
              uploadDoc(token.sasToken);
            }, (err) => {
              // Token fetch failed: nothing got uploaded, so settle the promise and
              // release the guard.
              deferred.reject(err);
              clearGuard();
            });
          }
        } else {
          deferred.resolve(true);
        }
        return deferred.promise;
      }

      this.checkSubmitterRole = (formUsers, formRoles) => {
        let resp = true;
        if (!!formUsers && !!formRoles && formRoles.length) {
          let crntUser = CacheService.currentUser;
          resp = false;
          let crntFrmUsr = formUsers.filter(fu => fu.userId == crntUser.userId);
          for (let u of crntFrmUsr) {
            if (!!formRoles.find(r => r.role == u.role && r.canSubmitForm)) {
              resp = true;
              break;
            }
          };
        }
        return resp;
      }

      this.navigateTo = (event, apiParams, entity, subjectId?,subject?) => {
        let currentUser = CacheService.getUser();
        let password = CacheService.getPassword();
        if (apiParams.type == "viewForm") {
          this.viewForm(0, entity.assignedFormId, 'dshbd-cmpf', subjectId);
        } else if(apiParams.type == "fillOutForm"){
            this.fillForm(entity.assignedFormId, 'dshbd-asf', subjectId);
        }else if(apiParams.type == "fillOutSubmittedForm"){
          this.fillForm(entity.assignedFormId, 'dshbd-cmpf', subjectId);
        } else if(apiParams.type == "parentFolder"){
            $state.go('documents-load', { action: 'list-rl', stateParams: { folderId: entity.parentFolderId } });
        }else if(apiParams.type == "normalDocParentFolder"){
            $state.go('documents-load', { action: 'list-document', stateParams: { folderId: entity.parentFolderId } });
        }else if(apiParams.type == "viewInBrowser"){
            this.DocumentService.getDocumentLink(entity.post);
        }else if (apiParams.type == "selfAssignForm"){
          let perm = !!subject && !!subject.userPerm? subject.userPerm[TargetEnum.FORM][PermissionsEnum.SELF_ASSIGN] : null;
          if(this.isFormAssignable(subject,entity,perm,currentUser)){
            let formUsers = [];
            if (!entity.roles || entity.roles.length == 0) {
              let user = {
                "userId": currentUser && currentUser.id,
                "role": "ACCESS"
              };
              formUsers.push(user);
            }
            ApiAdapterService.assignFormToUser(entity.formTemplateId, subject.subjectId, formUsers).then(
              (s) => {
                  this.fillForm(s.assignedFormId, 'dshbd-asf', subject.subjectId);
              },
              (e) => {
                toastr.success(Util.ASSIGN_FORM_ERROR);
              });
          }
        }else if(apiParams.type == "printForm"){
          ApiAdapterService.getFormTemplateByType(subject.teamOrgId,entity.sectionKey).then((s) => {
            BroadcastService.broadcast('print-form', [s]);
          }, (e) => {
            console.error(e);
          });

        } else if (apiParams.type == "selfShareForm"){
          let perm = !!subject && !!subject.userPerm? subject.userPerm[TargetEnum.FORM][PermissionsEnum.SELF_ASSIGN] : null;
          if(!!perm){
            ApiAdapterService.checkAndShareForm(entity.assignedFormId, subjectId, password).then((s) => {
              this.fillForm(entity.assignedFormId, 'dshbd-asf', subjectId);
            }, (e) => {
              toastr.success(Util.ASSIGN_FORM_ERROR);
            });
          }
        }else if(apiParams.type == "viewInNewTab"){
            window.open(entity.link,"_blank");
        }else if(apiParams.type == "viewInDetails"){
            $state.go('documents-load', {
                action: 'view-document',
                stateParams: {
                    documentId: entity.post.id,
                    folderId: entity.post.documentFolderId,
                    postType: entity.post.postType
                }
            });
        }
      }
    }
  }


angular.module('eCareVault.common.services')
  .service('FormService', FormService);
